import React, { useContext } from "react";
import yearContext from "../../Global varaibles/Year_filter/Year_context";

function YearFilter() {
  const years = ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019"];
  const context = useContext(yearContext);
  const { setYear } = context;

  return (
    <>
      <li>
        <button
          className="dropdown-item"
          onClick={() => {
            setYear("");
          }}
        >
          All
        </button>
      </li>

      {years.map((e, index) => (
        <li key={index}>
          <button
            className="dropdown-item"
            onClick={() => {
              setYear(e);
            }}
          >
            {e}
          </button>
        </li>
      ))}
    </>
  );
}

export default YearFilter;

